import { useState, useEffect } from 'react';

// utils
import axios from '../../../utils/axios';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, Link } from '@mui/material';
// components
import MenuPopover from '../../../components/MenuPopover';
import { IconButtonAnimate } from '../../../components/animate';
// icons
import PersonIcon from '@mui/icons-material/Person';
//
import { useTranslation } from "react-i18next";

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'home',
    linkTo: '/',
  },
  {
    label: 'profile',
    linkTo: '/dashboard/profile',
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const [user, setUser] = useState({});
  const { t, i18n } = useTranslation();

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const getProfile = async () => {
    axios
      .post("/auth/profile")
      .then((res) => {
        const user = res.data.user;
        setUser(user);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  useEffect(() => {
    getProfile();
  } ,[]);

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar alt={`${user.name} ${user.surname}`}>
          <PersonIcon />
        </Avatar>
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {`${user.name} ${user.surname}`}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} component={Link} href={option.linkTo} onClick={handleClose}>
              {t(`navbars.profile.items.${option.label}`)}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem 
          component={Link} 
          href={"/auth/logout"}
          sx={{ m: 1 }}>
            {t(`navbars.profile.items.logout`)}
        </MenuItem>
      </MenuPopover>
    </>
  );
}
